/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { Link } from '@reach/router';
import {AuthContext} from '../../AuthContext';
import _ from 'lodash';

import ChangePassword from './changepassword';
import NotificationBell from '../Custom/NotificationsBell';

const Index = () => {

    const [isChangePasswordShown, showChangePassword] = useState(false);

    const { userData } = useContext(AuthContext);

    return (
        <header class="topnavbar-wrapper" style={{ zIndex: -999 }}>
            <nav class="navbar topnavbar">
                <div class="navbar-header">
                    <Link class="navbar-brand" to="/">
                        <div class="brand-logo">
                            <img class="img-fluid" width='70' height='auto' src="/img/alex_white_logo.png" alt="App Logo"/>
                            {/* <span style={{ fontSize: 20, color: '#EFF5F3', marginLeft: 5 }}>ALEX</span> */}
                        </div>
                        <div class="brand-logo-collapsed">
                            {/* <img class="img-fluid" src="img/logo-single.png" alt="App Logo"/> */}
                            <img class="img-fluid" src="/img/alex_white_logo.png" alt="App Logo"/>
                            {/* <span style={{ fontSize: 16, color: '#EFF5F3' }}>ALEX</span> */}
                        </div>
                    </Link>
                </div>
                <ul class="navbar-nav mr-auto flex-row">
                    <li class="nav-item">
                        <a class="nav-link d-none d-md-block d-lg-block d-xl-block" href="#" data-trigger-resize="" data-toggle-state="aside-collapsed"><em class="fas fa-bars"></em></a>
                        <a class="nav-link sidebar-toggle d-md-none" href="#" data-toggle-state="aside-toggled" data-no-persist="true"><em class="fas fa-bars"></em></a>
                    </li>
                    {/* <li class="nav-item d-none d-md-block">
                        <a class="nav-link" id="user-block-toggle" href="#user-block" data-toggle="collapse"><em class="icon-user"></em></a>
                    </li> */}
                    {/* <li class="nav-item d-none d-md-block">
                        <a class="nav-link" href="lock.html" title="Lock screen"><em class="icon-lock"></em></a>
                    </li> */}
                </ul>
                <ul class="navbar-nav flex-row">
                    {/* <li class="nav-item">
                        <a class="nav-link" href="#" data-search-open=""><em class="icon-magnifier"></em></a>
                    </li> */}
                    {/* <li class="nav-item d-none d-md-block">
                        <a class="nav-link" href="#" data-toggle-fullscreen=""><em class="fas fa-expand"></em></a>
                    </li> */}
                    <NotificationBell empid={userData.empid} />
                    {/* <li class="nav-item"><a class="nav-link" href="#" data-toggle-state="offsidebar-open" data-no-persist="true"><em class="icon-notebook"></em></a></li> */}
                    {/* <li class="nav-item" title='Change Password'>
                        <span class="nav-link" onClick={() => {
                            showChangePassword(true);
                        }}><em class="fas fa-user-lock"></em></span>
                    </li> */}
                    <li class="nav-item" title='Logout'>
                        <Link class="nav-link" to='/logout'><em class="icon-logout"></em></Link>
                    </li>
                </ul>
                <form class="navbar-form" role="search" action="http://themicon.co/theme/angle/v4.8/static-html/app/search.html">
                    <div class="form-group">
                        <input class="form-control" type="text" placeholder="Type and hit enter ..."/>
                        <div class="fas fa-times navbar-form-close" data-search-dismiss=""></div>
                    </div>
                    <button class="d-none" type="submit">Submit</button>
                </form>
            </nav>
            {
                isChangePasswordShown &&
                <ChangePassword
                    userData={userData}
                    visible={isChangePasswordShown}
                    onCancel={() => {
                        showChangePassword(false);
                    }}
                />
            }
        </header>
    );
};

export default Index;